<template>
    <profile-card title="Products">
        <form @submit.prevent="create">
            <div class="acc-setting profile-series-h">
                <div class="product-cp-field cp-field ">
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="title">Title</label>
                            <multiselect
                                    autocomplete="off"
                                    v-model="title"
                                    tag-placeholder="Add this as a new product"
                                    label="title"
                                    track-by="title"
                                    placeholder="Title"
                                    :options="suggestions"
                                    :multiple="false"
                                    :taggable="true"
                                    :loading="loading"
                                    @select="selectTitle"
                                    @tag="addProduct"
                                    @search-change="searchTitle"
                                    @remove="removeTitle"
                                    id="title"
                            ></multiselect>
                        </div>

                        
                        <div class="form-group col-12">
                            <label for="price">Price</label>

                            <div class="input-group mb-3">
                           
                            <input type="text" name id="price"  class="form-control" v-model="current.price">
                            <div class="input-group-append">
                                <span class="input-group-text" style="font-size: 20px;font-weight: bold;">$</span>
                            </div>
                            </div>
                        </div>                            
                        <div class="form-group col-12">
                            <label for="category">Category</label>
                            <select id="category" v-model="current.category" class="form-control category-select">
                                <option
                                        v-for="(single,index) in categories"
                                        :key="index"
                                        :value="single.id"
                                >{{single.title}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- <div class="cp-field">
                  <file-pond
                    name="test"
                    ref="pond"
                    v-model="image"
                    label-idle="Drop image here..."
                    v-bind:allow-multiple="false"
                    :files="image"
                    accepted-file-types="image/jpeg, image/png, image/jpg"
                  />
                </div>-->

                <div class="cp-field">
                    <div class="form-row">
                        <div class="form-group col">
                            <switch-btn
                                    label="This product contains promotion"
                                    switch_id="dfsdfsd"
                                    label_style="margin: 20px 0 -15px 0;"
                                    v-model="current.promotion"
                            ></switch-btn>
                        </div>
                    </div>
                </div>

                <div class="cp-field" v-if="current.promotion">
                    <div class="form-row">
                        <div class="form-group col-4">
                            <label for="percent">Percent</label>
                            <input type="text" id="percent" class="form-control" v-model="current.percent"/>
                        </div>
                        <div class="form-group col-4">
                            <label for="price">Start date</label>
                            <VueCtkDateTimePicker
                                    :onlyDate="true"
                                    formatted="ll"
                                    format="YYYY-MM-DD"
                                    v-model="current.start_date"
                                    locale="en"
                            >
                                <input type="text" class="form-control" v-model="current.start_date"/>
                            </VueCtkDateTimePicker>
                        </div>
                        <div class="form-group col-4">
                            <label for="price">End date</label>
                            <VueCtkDateTimePicker
                                    :onlyDate="true"
                                    formatted="ll"
                                    format="YYYY-MM-DD"
                                    v-model="current.end_date"
                                    locale="en"
                            >
                                <input type="text" class="form-control" v-model="current.end_date"/>
                            </VueCtkDateTimePicker>
                        </div>
                    </div>
                </div>

                <div class="save-stngs pd2">
                    <ul>
                        <li>
                            <button class="ps-btn ps-btn--sm" type="submit" style="margin-top:14px;">Save</button>
                        </li>
                    </ul>
                </div>
                <div v-if="loading" class="cp-field">
                    <div class="form-row">
                        <div class="form-group col">
                            <label>
                                <loading
                                        :active="loading"
                                        :can-cancel="false"
                                        loader="dots"
                                        color="#2292ef"
                                        :is-full-page="false"
                                ></loading>
                            </label>
                        </div>
                    </div>
                </div>
                <!--save-stngs end-->
                <div v-else class="container">
                    <table class="table table-bordered" style="margin-bottom:10px;">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Title</th>
                            <th scope="col">Category</th>
                            <th scope="col">Price</th>
                            <th scope="col">Promotion</th>
                            <th scope="col">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(single, i) in products" :key="i">
                            <td scope="row" style="width:80px;">{{ i + 1 }}</td>
                            <td style="width:100px;">{{single.product.title}}</td>
                            <td>
                                <div v-if="single.product.category != null">{{single.product.category.title}}</div>
                            </td>
                            <td>
                                <div>{{ single.price }}</div>
                            </td>
                            <td>
                                <add-promotion button-title="Promotion" :user-product="single"></add-promotion>
                            </td>
                            <td style="width:80px;" class="table-kqr">
                                <a @click.prevent="deleteProduct(single.id,i)" href="#">
                                    <i class="fa fa-trash"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </form>
    </profile-card>
</template>

<script>
    // Import Vue FilePond
    import vueFilePond from "vue-filepond";

    // Import FilePond styles
    import "filepond/dist/filepond.min.css";

    // Import FilePond plugins
    // Please note that you need to install these plugins separately

    // Import image preview plugin styles
    import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginImagePreview from "filepond-plugin-image-preview";
    import FilePondPluginFileEncode from "filepond-plugin-file-encode";

    // Create component
    const FilePond = vueFilePond(
        FilePondPluginFileValidateType,
        FilePondPluginImagePreview,
        FilePondPluginFileEncode
    );
    import SwitchBtn from "nice-switch-btn";
    import TraderDoneTasks from "./../../../TraderDoneTasks";
    import CoolLightBox from "vue-cool-lightbox";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import Multiselect from "vue-multiselect";
    import EventBus from '../../../../front/eventBus';

    export default {
        components: {
            CoolLightBox,
            SwitchBtn,
            TraderDoneTasks,
            Loading,
            Multiselect
        },
        props: {},
        data() {
            return {
                current: {
                    category: null,
                    title: null,
                    isNew: false,
                    productId: null,
                    price: null,
                    promotion: null
                },
                errors: null,
                title: null,
                categories: [],
                loading: false,
                suggestions: [],
                products: [],
            };
        },
        created() {
            this.loading = true;
            axios.get("/dashboard/products/index").then(res => {
                this.categories = res.data.categories;
                this.products = res.data.products;
                this.suggestions = res.data.suggestions;
                this.loading = false;
            });
        },
        mounted(){
            EventBus.$on('PROMOTION_CHANGED', () => {
                this.refreshUserProducts();
            })
        },
        methods: {
            selectTitle(title) {
                this.current.title = title.title;
                this.current.isNew = false;
                this.current.productId = title.id;
            },
            searchTitle(query) {
                if (query.length >= 3) {
                    this.loading = true;
                    axios.get(`/dashboard/products/search?q=${query}`).then(res => {
                        this.suggestions = res.data.data;
                        this.loading = false;
                    });
                }
            },
            refreshUserProducts(){
                this.loading = true;
                axios.get("/dashboard/products/all").then(res => {
                    this.products = res.data.products;
                    this.loading = false;
                    this.removeTitle();
                });
            },
            addProduct(title) {
                this.title = {title: title};
                this.current.title = title;
                this.current.isNew = true;
                this.current.productId = null;
            },
            removeTitle() {
                this.title = null;
                this.current.title = null;
                this.current.isNew = false;
                this.current.productId = null;
            },
            create() {
                this.loading = false;
                let self = this;
                axios.post("/dashboard/product", this.current).then(res => {
                    if (res.data.promotion_id != 0) {
                        res.data.data.promotionId = res.data.promotion_id;
                    }else {
                        res.data.data.promotionId = 0;
                    }
                    this.products.push(res.data.data);
                    this.current = {
                        category: null,
                        title: null,
                        isNew: false,
                        productId: null,
                        price: null,
                        promotion: false,
                        discount: null,
                        end_date: null,
                        start_date: null
                    };
                    this.loading = false;
                    EventBus.$emit('PROMOTION_CHANGED')
                }).catch(function(err) {
                        console.log(err);
                        if (err.response.status == 422) {
                            let errors = err.response.data.errors;
                            self.errors = errors;
                            for (let error in errors) {
                                self.$toast.error(errors[error][0]);
                            }
                        }
                    });
            },
            deleteProduct(id, index) {
                axios.delete(`/dashboard/product/${id}`).then(res => {
                    if (res.data.status) this.products.splice(index, 1);
                });
            }
        }
    };
</script>
<style scoped></style>
